module.exports = __webpack_public_path__ + "static/media/electricity.f6b0db8d.png";